import React, { Fragment, useMemo } from 'react';
import { JobItem } from '../../types';
import { JobsRowList } from '../JobsRowList';

export interface JobsListProps {
  todayList: JobItem[];
  yesterdayList: JobItem[];
  olderList: JobItem[];
  onViewReport: () => void;
  onDropdownChange: (option: string) => void;
}

export const JobsList: React.FC<JobsListProps> = ({
  todayList,
  yesterdayList,
  olderList,
  onDropdownChange,
  onViewReport,
}) => {
  const lists = useMemo(
    () => [
      { label: 'Today', list: todayList },
      { label: 'Yesterday', list: yesterdayList },
      { label: 'Older', list: olderList },
    ],
    [olderList, todayList, yesterdayList]
  );

  return (
    <div className="jobs-list">
      {lists.map(({ label, list }) => (
        <Fragment key={label}>
          {list.length > 0 ? (
            <JobsRowList
              label={label}
              list={list}
              onViewReport={onViewReport}
              onDropdownChange={onDropdownChange}
            />
          ) : null}
        </Fragment>
      ))}
    </div>
  );
};
